import React, { useEffect, useState } from 'react';
import './styles.css';
import Notification from '../../components/Notification';
import User from '../../components/User';
import { useMediaQuery } from '@mui/material';
import { Beneficiario } from '../../interfaces/entities/Beneficiario';
import { getBenef } from '../../Store/storages/BeneficiarioStorage';
import Accessibility from '../../components/Accessibility';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import { getTipoUsuario } from '../../utils/getTipoUsuario';
import { useNotification } from '../../Store/contexts/NotificationContext';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router';
import './styles.css';

const Header: React.FC = () => {
  const [benef, setBenef] = useState<Beneficiario | null>(null);
  const { updateUnreadNotificationsNumber } = useNotification();
  const navigate = useNavigate();

  const {
    contrastMode,
    contrastStyle,
    calculateFontStyle,
    fontSizeStyleAccessibility,
    alterFontSizeMode,
    fontSize } = useAccessibility();

  useEffect(() => {
    const benef = getBenef();
    setBenef(benef);

    const getNotifications = async () => {
      await updateUnreadNotificationsNumber();
    }

    getNotifications();
  }, [])

  return (
    <header style={{ ...contrastStyle, borderTop: contrastMode ? '1px solid white' : '', borderBottom: contrastMode ? '1px solid white' : '' }} className={`${alterFontSizeMode && 'header-accessibility'}`}>
      <div className={`header-content ${contrastMode && 'contrast-font'}`}>
        <div className="info">
          <h1 className='client-chanel' style={calculateFontStyle(20)}>Canal do Cliente</h1>
          <div className={`card-holder ${fontSize >= 25 && 'card-holder-accessibility'}`}>
            <h2 className='client-card' style={calculateFontStyle(14)}>
              Cartão {benef?.login} ({getTipoUsuario(benef?.tipoUsr || '')} - {benef?.indStatusBenef ? 'Ativo' : 'Inativo'})
            </h2>
            {/* ACESSO AO CARTÃO VIRTUAL DESATIVADO VIA HEADER CANALPF-1675 (AZURE) 05/12/2024
             <button
              onClick={() => navigate('/saudeOnline/cartaoVirtual')}
              style={fontSizeStyleAccessibility}
              className={`${alterFontSizeMode ? 'text-wrap' : 'no-wrap'}`}>
              Cartão Virtual
              <FontAwesomeIcon icon={faChevronRight} />
            </button> */}
          </div>
          <h2 className='product' style={calculateFontStyle(14)}>{benef?.produto.descricaoProduto}</h2>
        </div>
        <div className="actions">
          {useMediaQuery('(min-width: 899px)') && <Accessibility />}

          <div className="client-actions">
            {/* TO DO: Voltar ícone notificação */}
            <Notification />
            {useMediaQuery('(min-width: 899px)') && <User beneficiario={benef} />}
          </div>

        </div>
      </div>
    </header>
  )
}

export default Header